import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HdFormComponent } from './hd-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { HdButtonModule } from '../hd-button/hd-button.module';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroAntdModule,
    HdButtonModule
  ],
  declarations: [HdFormComponent],
  exports: [HdFormComponent]
})
export class HdFormModule { }
